const daily_budget_type = {
  label: '日预算',
  type: 'radio-group',
  isButton: true,
  options: [
    {
      label: '不限',
      value: 'BUDGET_MODE_INFINITE',
    },
    {
      label: '指定预算',
      value: 'BUDGET_MODE_DAY',
    },
  ],
  props: {
    disabled: false,
  },
  rules: {
    required: true,
    message: '请选择日预算',
    trigger: ['change'],
  },
  value: 'BUDGET_MODE_INFINITE',
};

const daily_budget = {
  label: ' ',
  type: 'input-number',
  hidden: true,
  rules: {
    required: true,
    message: '请输入日预算',
    trigger: ['change'],
  },
  props: {
    step: 1,
    precision: 0,
    min: 500,
    max: 999999999,
  },
  formItemTips: {
    props: {
      class: 'inline-block',
      style: {
        marginLeft: '10px',
      },
    },
    content: '元',
  },
  value: undefined,
};

const price_type = {
  label: '出价方式',
  type: 'radio-group',
  isButton: true,
  options: [],
  rules: {
    required: true,
    message: '请选择出价方式',
    trigger: ['change'],
  },
  value: 'PRICING_CPC',
};

const price = {
  label: '广告出价',
  type: 'input-number',
  rules: {
    required: true,
    message: '请输入广告出价',
    trigger: ['change'],
  },
  props: {
    step: 1,
    precision: 2,
    min: 0.01,
    max: 999999999.00,
  },
  formItemTips: {
    props: {
      class: 'inline-block',
      style: {
        marginLeft: '10px',
      },
    },
    content: '元',
  },
  value: undefined,
};

const price_strategy = {
  label: '出价策略',
  type: 'radio-group',
  hidden: true,
  isButton: true,
  options: [],
  rules: {
    required: true,
    message: '请选择出价策略',
    trigger: ['change'],
  },
  value: '',
};

const convert_id = {
  label: '转化事件',
  hidden: true,
  rules: {
    required: true,
    message: '请选择转化事件',
    trigger: ['change'],
  },
  value: '',
  isPreview: false,
};

const fusion__optimize_goal = {
  label: '优化目标',
  type: 'label',
  hidden: true,
  value: '',
};

const deep_convert_type = {
  label: '深度优化目标',
  type: 'select',
  hidden: true,
  rules: {
    required: false,
  },
  props: {
    disabled: false,
  },
  options: [],
  value: '',
};

const deep_convert_price = {
  label: '深度优化出价',
  type: 'input-number',
  hidden: true,
  rules: {
    required: true,
    message: '请输入深度优化出价',
    trigger: ['change'],
  },
  props: {
    step: 1,
    precision: 2,
    min: 0.01,
    max: 999999999.00,
  },
  formItemTips: {
    props: {
      class: 'inline-block',
      style: {
        marginLeft: '10px',
      },
    },
    content: '元',
  },
  value: undefined,
};

/**
 * 广告：广告预算与出价配置
 */
export {
  daily_budget_type, // 日预算类型
  daily_budget, // 日预算
  price_type, // 出价方式
  price_strategy, // 出价策略
  convert_id, // 转化ID
  fusion__optimize_goal, // 优化目标
  deep_convert_type, // 深度优化目标
  price, // 出价
  deep_convert_price, // 深度优化出价
};
